export default __webpack_public_path__ + "static/media/Astro_NorthNode_Black.002928ed.png";